class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer =this.closest('cart-drawer');
      const idx = this.dataset.index;
      const $drawerItem = $(`.cart-drawer__item[data-idx="${idx}"]`);
      const drawerItemProduct = $drawerItem.data('cart-drawer-product');
      const drawerItemQty = $drawerItem.find('[data-cart-drawer-quantity]').data('cart-drawer-quantity');
      const kitId = $drawerItem.data('kit');

      let qtyChanges = {};
      if (kitId) {
        let itemsWithKitId = $(`.cart-drawer__item[data-kit="${kitId}"]`);

        for (let item of itemsWithKitId) {
          const itemQty = $(item).find('[data-cart-drawer-quantity]').data('cart-drawer-quantity') || 1;
          const itemIdx = $(item).data('idx');
          const itemProduct = $(item).data('cart-drawer-product');
          const itemKey = $(item).find('cart-drawer-remove-button').data('key');

          // Checks for same product or variant of product on a different line item, and preserves quantity if it matches
          qtyChanges[itemKey] = itemProduct === drawerItemProduct && itemIdx !== parseInt(idx, 10) ? itemQty : (itemQty - drawerItemQty < 0) ? 0 : itemQty - drawerItemQty;
        }

        cartDrawer.enableLoading();

        const body = JSON.stringify({
          updates: qtyChanges,
          sections: cartDrawer.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });


        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            cartDrawer.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              elementToReplace.innerHTML =
              cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));

            cartDrawer.disableLoading();
          }).catch((error) => {
            cartDrawer.disableLoading();
            console.log(error);
          });

      } else {
        this.closest('cart-drawer').updateQuantity(idx, 0);
      }

    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.siteHtml = document.querySelector('[data-site-html]')
    this.siteBody = document.querySelector('[data-site-body]')
    this.siteContainer = document.querySelector('[data-site-main')
    this.currentScroll = null
    this.drawer = document.getElementById('cart-drawer');

    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');
    this.pageOverlayElement.addEventListener('click', this.close.bind(this));

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // setTimeout(function(){
    //   Rebuy?.Cart?.fetchCart(function(){
    //     Rebuy.init();
    //   });
    // }, 250)

    // document.addEventListener('rebuy:cart.ready', (event) => {
    //   var x = this;
    //   document.addEventListener('rebuy.add', function(event) {
    //     const cartHidden = x.querySelector('.cart-drawer').getAttribute('aria-hidden')

    //     x.updateQuantity(1,1);

    //     if (cartHidden === 'true') {
    //       x.open();
    //     }
    //   });
    // });

    if (window.location.href.indexOf('?cart_redirect') >=0) {
      this.open();
    }

    this.setupCartFixObserver();
  }

  // ---- ADD THIS ----
  setupCartFixObserver() {
    const mutationNodeTarget = document.getElementById('cart-drawer__footer');
    const observer = new MutationObserver(() => {
      this.updateCheckoutButton();

      // Temporal fix for loop
      const delaysToOverwrite = [300, 500, 800, 1000, 1500, 2000];
      delaysToOverwrite.forEach((delay) => {
        setTimeout(() => {
          this.updateCheckoutButton();
        }, delay);
      });
    });

    observer.observe(mutationNodeTarget, {
      childList: true,
      subtree: true,
    });
  }

  updateCheckoutButton() {
    this.cleanUpTitle();
    this.cleanupCheckoutLabel();
  }

  cleanUpTitle() {
    const titleEl = this.querySelector('.loop-return-coverage__title');
    if (titleEl) {
      if (titleEl.innerHTML.includes('<br')) {
        titleEl.innerHTML = titleEl.textContent.trim();
      }
      if (titleEl.textContent.includes('+')) {
        titleEl.textContent = titleEl.textContent.replace('+', ' ').trim();
      }
    }
  }

  cleanupCheckoutLabel() {
    const button = this.querySelector('.loop-return-coverage__cta__plus');
    if (button && button.textContent.includes('|')) {
      button.textContent = button.textContent.split('|')[0].trim();
    }
    if (button && button.textContent.includes('+')) {
      button.textContent = button.textContent.replace('+', ' ').trim();
    }
  }

  // Remove any "_free_tier_gift" items when there is no Gift tier block configured
  async cleanupStaleFreeGifts() {
    try {
      // If there is still a Gift tier bar in the DOM, do nothing.
      // This means the promotion is still configured and the CartTierBar
      // component is responsible for managing the gift.
      const hasGiftTierBar = !!document.querySelector('cart-tier-bar[data-gift-variant-id]');
      if (hasGiftTierBar) return;

      // Fetch current cart data
      const cartRes = await fetch('/cart.json');
      if (!cartRes.ok) return;

      const cartData = await cartRes.json();
      if (!cartData.items || !cartData.items.length) return;

      // Find all line items that were added as free gifts
      const staleGiftItems = cartData.items.filter(
        (item) => item.properties && item.properties._free_tier_gift
      );

      if (!staleGiftItems.length) return;

      // Build "updates" payload to remove each stale gift line (set quantity to 0)
      const updates = {};
      staleGiftItems.forEach((item) => {
        updates[item.key] = 0;
      });

      const sectionsToRender = this.getSectionsToRender ? this.getSectionsToRender() : [];

      const body = JSON.stringify({
        updates,
        // keep the same pattern used elsewhere in CartDrawer for re-rendering
        sections: sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname,
      });

      this.enableLoading && this.enableLoading();

      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body,
      });

      const state = await response.text();
      const parsedState = JSON.parse(state);

      sectionsToRender.forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const elementToReplace =
          container.querySelector(section.selector) || container;

        elementToReplace.innerHTML = this.getSectionInnerHTML
          ? this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
          : parsedState.sections[section.section];
      });

      this.disableLoading && this.disableLoading();
    } catch (error) {
      console.error('[CartDrawer] Failed to cleanup stale free gifts', error);
      this.disableLoading && this.disableLoading();
    }
  }

  open() {
    const closeButton = this.closeIcon;
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);
    this.scrollLockOpen()
    trapFocus(this.drawer);

    this.pageOverlayElement.classList.add('is-visible');

    document.body.addEventListener('click', this.onBodyClick);

     this.cleanupStaleFreeGifts();

   // Debug: log cart state every time the drawer opens
    fetch('/cart.json')
      .then(r => r.json())
      .then(cart => {
        console.log('[Cart Debug] cart.json items:', cart.items.map(i => ({
          title: i.title,
          variant_id: i.id,
          key: i.key,
          final_line_price: i.final_line_price,
          properties: i.properties,
          quantity: i.quantity
        })));
      });

  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);
    this.scrollLockClose()

    this.pageOverlayElement.classList.remove('is-visible');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus();
  }

  scrollLockOpen() {
    this.currentScroll = window.scrollY
    this.siteContainer.style.top = `-${this.currentScroll}px`
    this.siteHtml.classList.add('scroll-lock')
    this.siteBody.classList.add('scroll-lock')
  }

  scrollLockClose() {
    this.siteContainer.style.top = ''
    this.siteHtml.classList.remove('scroll-lock')
    this.siteBody.classList.remove('scroll-lock')
    if (this.currentScroll !== null) {
      window.scrollTo(0, this.currentScroll)
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));

    setTimeout(function() {
      $.getScript(function() {
        getDrawerProductUpdate();
        //setTimeout(function(){ Rebuy.init(); }, 500)
      });
    }, 500);
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));

        this.disableLoading();
        // Rebuy.init();
      }).catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer__header',
        section: document.getElementById('cart-drawer__header').dataset.id,
        selector: '.cart-drawer__header',
      },
      {
        id: 'cart-drawer__footer',
        section: document.getElementById('cart-drawer__footer').dataset.id,
        selector: '.cart-drawer__footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    const drawerLoading = document.getElementById('cart-drawer-loading');

    if (drawerLoading) {
      drawerLoading.classList.remove('hidden');
    }
  }

  disableLoading() {
    const drawerLoading = document.getElementById('cart-drawer-loading');

    if (drawerLoading) {
      document.getElementById('cart-drawer-loading').classList.add('hidden');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (!document.querySelector('.js-open-cart') && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartTierBar extends HTMLElement {
  constructor() {
    super();
    this.checkIfFreeGift();
  }

  async checkIfFreeGift() {
    const freeGiftVariantId = this.getAttribute('data-gift-variant-id');
    if (!freeGiftVariantId) return;

    const cartDataResponse = await fetch('/cart.json');
    const cartData = await cartDataResponse.json();
    if (!cartData.items.length) return;

    // Find the current free gift line item in the cart
    const matchingProduct = cartData.items.find(
      (item) =>
        item.id === parseInt(freeGiftVariantId, 10) &&
        item.properties &&
        item.properties._free_tier_gift
    );

    // 🔐 Guard 1: If the “free gift” is no longer free (its price > 0), remove it immediately
    // This prevents users from checking out with a gift that used to be free but is no longer part of the promotion.
    if (matchingProduct && matchingProduct.final_line_price > 0) {
      await this.removeFreeGift(matchingProduct.key);
      return;
    }

    // 🔐 Original logic: synchronize the free gift with the tier qualification state
    if (this.hasAttribute('data-tier-qualified')) {
      // If user qualifies for the gift:
      // - If it is already in the cart, correct the quantity if needed
      // - Otherwise, add it
      if (matchingProduct) {
        this.checkFreeGiftQuantity(matchingProduct.key);
      } else {
        this.addFreeGift(freeGiftVariantId);
      }
    } else if (matchingProduct) {
      // If user no longer qualifies but the gift is still in the cart, remove it
      this.removeFreeGift(matchingProduct.key);
    }
  }


  addFreeGift(variantId) {
    const lineItem = {
      id: variantId,
      quantity: 1,
      properties: {
        '_free_tier_gift': true
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(lineItem)
    }).then((response) => {
      return response.json()
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description)
      }

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(result.sections[section.section], section.selector);
      }));

      return null
    }).catch((error) => {
      console.log(error)
    })
  }

  removeFreeGift(itemKey) {
    const lineItem = {
      id: itemKey,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(lineItem)
    }).then((response) => {
      return response.json()
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description)
      }

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(result.sections[section.section], section.selector);
      }));

      return null
    }).catch((error) => {
      console.log(error)
    })
  }

  async checkFreeGiftQuantity(itemKey) {
    const cartDataResponse = await fetch('/cart.json');
    const cartData = await cartDataResponse.json();
    const matchingProduct = cartData.items.find((item) => item.key === itemKey);

    if (!matchingProduct || matchingProduct.quantity === 1) { return; }

    const lineItem = {
      id: itemKey,
      quantity: 1,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(lineItem)
    }).then((response) => {
      return response.json()
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description)
      }

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(result.sections[section.section], section.selector);
      }));

      return null
    }).catch((error) => {
      console.log(error)
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer__header',
        section: document.getElementById('cart-drawer__header').dataset.id,
        selector: '.cart-drawer__header',
      },
      {
        id: 'cart-drawer__footer',
        section: document.getElementById('cart-drawer__footer').dataset.id,
        selector: '.cart-drawer__footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-tier-bar', CartTierBar);
class CartDiscount extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[data-cart-discount-input]')
    this.submit = this.querySelector('[data-cart-discount-submit]')
    this.store = window.theme.storefront.store
    this.apiToken = window.theme.storefront.apiToken
    this.removeButtons = this.querySelectorAll('[data-remove-discount]')
    this.errorMessage = this.querySelector('[data-error-message]')
    this.getCartId()
  }

  async getCartId() {
    this.cartData = await this.fetchCartId()
    this.cartId = await this.getCartToken()
    this.cartDiscounts = this.cartData.cart_level_discount_applications.map(discount => discount.title)
    this.init()
  }

  init () {
    this.input.addEventListener('keydown', (event) => {
      if (event.keyCode !== 13) { return }
      event.preventDefault()
      this.submitCode()
    })
    this.submit.addEventListener('click', () => { this.submitCode() })
    this.removeButtons.forEach(removeButton => {
      removeButton.addEventListener('click', () => {
        this.removeCode(removeButton.dataset.discount)
      })
    })
  }

  async getCartToken () {
    const cookieToken = this.getCookie('cart')
    if (cookieToken) {
      return decodeURIComponent(cookieToken)
    }

    return this.cartData.token
  }

  async fetchCartId() {
    try {
      const res = await fetch('/cart.json')
      if (!res.ok) { throw new Error(res.statusText) }
      return await res.json()
    } catch (err) {
      console.error(err)
    }
  }

  submitCode () {
    const code = this.input.value
    if (!code) { return }
    const discountCodes = [...this.cartDiscounts]
    discountCodes.push(code)
    this.storefrontDiscountUpdate(discountCodes, code)
  }

  removeCode (code) {
    const discountCodes = [...this.cartDiscounts].filter(discount => discount != code)
    this.storefrontDiscountUpdate(discountCodes)
  }

  async storefrontDiscountUpdate(discountCodes, code) {
    this.input.classList.remove('has-error')
    this.errorMessage.classList.add('hidden')
    const url = `https://${this.store}/api/graphql`
    const query = `
      mutation CartDiscountCodesUpdate {
        cartDiscountCodesUpdate(
          cartId: "gid://shopify/Cart/${this.cartId}",
          discountCodes: ${JSON.stringify(discountCodes)}
        ) {
          cart {
            id
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.apiToken
      },
      body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then((data) => {
      this.checkValidity(code, data.data.cartDiscountCodesUpdate.cart.discountCodes)
    })
    .catch(error => console.error('Error:', error))
  }

  checkValidity(enteredCode, codes) {
    if (enteredCode) {
      const codeData = codes.find(code => code.code === enteredCode)
      if (!codeData.applicable) {
        this.input.classList.add('has-error');
        this.errorMessage.classList.remove('hidden')
        return
      }
    }

    this.updateSections()
  }

  async updateSections () {
    const sectionsIds = this.getSectionsToRender().map(section => section.section)
    const url = `/?sections=${sectionsIds.join(',')}`
    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then((response) => {
      return response.json()
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description)
      }

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(result[section.section], section.selector);
      }));

      return null
    }).catch((error) => {
      console.log(error)
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-drawer__header',
        section: document.getElementById('cart-drawer__header').dataset.id,
        selector: '.cart-drawer__header',
      },
      {
        id: 'cart-drawer__footer',
        section: document.getElementById('cart-drawer__footer').dataset.id,
        selector: '.cart-drawer__footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }


  getCookie (cname) {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}

customElements.define('cart-discount', CartDiscount);

class CartBundleUpsell extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-cart-upsell-button]')
    this.parentLineItemKey = this.dataset.parentLineItemKey
    this.sellingPlan = this.dataset.sellingPlan
    this.kitId = this.dataset.kitId
    this.upsellVariantId = Number(this.dataset.upsellVariantId)
    this.parentLineItem = {}
    this.otherKitItems = {}
    this.cart = this.closest('#cart-drawer')

    this.getCartDetails()
  }

  async getCartDetails () {
    this.cartData = await this.getCart()
    this.parentLineItem = this.cartData.items.find(item => item.key === this.parentLineItemKey)

    if (!this.parentLineItem) {
      this.classList.add('hide')
      return
    }

    this.otherKitItem = this.cartData.items.find(item => !!item.properties._kitID && item.properties._kitID === this.parentLineItem.properties._kitID && item.product_id != this.parentLineItem.product_id)

    this.init()
  }

  async getCart() {
    try {
      const res = await fetch('/cart.json')
      if (!res.ok) { throw new Error(res.statusText) }
      return await res.json()
    } catch (err) {
      console.error(err)
    }
  }

  async init () {
    this.button.addEventListener('click', () => {
      this.button.disabled = true
      this.cart && this.cart.classList.add('disable-actions')
      this.modifyCartProducts()
    })
  }

  async modifyCartProducts () {
    const itemsToModify = {}
    itemsToModify[this.parentLineItemKey] = this.parentLineItem.quantity - 1
    if (this.otherKitItem) itemsToModify[this.otherKitItem.key] = this.otherKitItem.quantity - 1

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: itemsToModify
      }),
    })
    .then(response => response.json())
    .then(data => {
      this.addNewBundledProducts();
    })
    .catch((err) => {
      console.error(err)
    })
  }

  async addNewBundledProducts () {
    const itemsToAdd = [
      {
        id: this.parentLineItem.id,
        quantity: 1,
        properties: {
          _kitID: this.kitId
        }
      },
      {
        id: this.upsellVariantId,
        quantity: 1,
        properties: {
          _kitID: this.kitId
        },
        ...(this.sellingPlan && { selling_plan: this.sellingPlan })
      }
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      }),
    })
    .then(response => response.json())
    .then(result => {
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
        elementToReplace.innerHTML = this.getSectionInnerHTML(result.sections[section.section], section.selector)
      }))
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      this.cart && this.cart.classList.remove('disable-actions')
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer__header',
        section: document.getElementById('cart-drawer__header').dataset.id,
        selector: '.cart-drawer__header',
      },
      {
        id: 'cart-drawer__footer',
        section: document.getElementById('cart-drawer__footer').dataset.id,
        selector: '.cart-drawer__footer',
      }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }
}

customElements.define('cart-bundle-upsell', CartBundleUpsell);